import React from "react";
import DecoMethodCategoryContainer from "./DecoMethodCategoryContainer";

function DecoMethodCategory() {
  return (
    <div className="p-3">
      <DecoMethodCategoryContainer />
    </div>
  );
}

export default DecoMethodCategory;
